export default __webpack_public_path__ + "static/media/kirvano.3ba706ed.png";